import React from "react";
import { useTranslation } from "react-i18next";
import HeroSlider from "./HeroSlider/HeroSlider";
import ProjectLanding from "./ProjectLanding/ProjectLanding";
import OnGoingProjects from "./OnGoingProjects/OnGoingProjects";
// fetching
import { useEffect, useState } from "react";
import useFetch from "Hooks/useFetch";
import IsLoading from "Components/RequestHandler/IsLoading";
import IsError from "Components/RequestHandler/IsError";

const Projects = () => {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fetchData, error } = useFetch();
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState("completed");

  const getData = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await fetchData("projects");
      setData(data);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  if (isLoading) return <IsLoading />;
  if (error || isError) return <IsError />;
  if (data) {
    return (
      <main className="bg-black ">
        <HeroSlider data={data?.gallery} />
        <div className="text-secondary px-10 lg:px-20 py-20 flex items-center gap-x-6">
          <button
            className={`border border-secondary px-6 lg:px-10 py-2 ${
              selectedTab === "completed"
                ? "bg-secondary text-primary"
                : "bg-transparent"
            }`}
            onClick={() => setSelectedTab("completed")}
          >
            {t("completed_project")}
          </button>
          <button
            className={`border border-secondary px-6 lg:px-10 py-2 ${
              selectedTab === "ongoing"
                ? "bg-secondary text-primary"
                : "bg-transparent"
            }`}
            onClick={() => setSelectedTab("ongoing")}
          >
            {t("ongoing_project")}
          </button>
        </div>
        {selectedTab === "completed" && (
          <ProjectLanding data={data?.projectsSummary} />
        )}
        {selectedTab === "ongoing" && (
          <OnGoingProjects data={data?.ongoing_project} />
        )}
      </main>
    );
  }
};

export default Projects;
